import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-maps-references',
  storeModule.createStoreModule('real-estate-developments-maps-references')
)
